<template>
<v-dialog v-model="show" max-width="600">
  <template v-slot:activator="{on}">
    <v-btn v-on="on" icon color="orange darken-1"><v-icon>edit</v-icon></v-btn>
  </template>
  <v-card :loading="saving" :disabled="saving">
    <CardTitle title="Edit Note">
      <template v-slot:actions>
        <Confirm @confirmed="deleteNote()">
          <template v-slot:activator="{on}">
            <v-btn v-on="on" color="error" small>delete</v-btn>
          </template>
        </Confirm>
      </template>
    </CardTitle>
    <v-card-text>
      <v-form ref="form" @submit="save">
        <v-autocomplete v-model="form.sample_note_type_uuid" label="Note type" :items="$store.$db().model('sampleNoteTypes').all()" item-text="name" item-value="uuid"></v-autocomplete>
        <v-textarea v-model="form.note" label="Note"></v-textarea>
      </v-form>
    </v-card-text>
    <CardActions @close="show = false" @submit="save"></CardActions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
    name: "SampleEditNote",
    components: {},
    data: () => ({
      show: false,
      saving: false,
      form:{
        uuid: null,
        sample_note_type_uuid: null,
        note: null,
        created_by: null,
        updated_by: null,
      }
    }),
    props: {
      note: {
        required: true
      }
    },
  mounted(){
      const note = {...this.note}
      this.form = note;
  },
  methods: {
      async deleteNote(){
        await this.$store.$db().model('sampleNotes').api().destroy(this.note.uuid, 'Deleted note: '+this.note.note)
      },
      async save(){
        if(!this.$refs.form.validate()) return;
        try{
          this.saving = true
          this.form.updated_by = this.$store.getters.id;
          await this.$store.$db().model('sampleNotes').api().save(this.form)
        }catch(e){
          this.$store.dispatch("showError", "Failed to save note")
        }finally{
          this.saving = false;
          this.show = false;
        }
      }
  }
}
</script>

<style scoped>

</style>
